import { App } from '@capacitor/app'
import { Network } from '@capacitor/network'

import { useIsNative } from '~/composables/usePlatform'

export default defineNuxtPlugin(async _nuxtApp => {
  const isNative = useIsNative()

  if (!isNative) return

  const forceNavigateToOffline = () => {
    const currentPath = window.location.pathname
    if (currentPath === '/error/no-connection') return
    window.location.replace('/error/no-connection')
  }

  const checkNetworkAndNavigate = async () => {
    const status = await Network.getStatus()
    const currentPath = window.location.pathname

    if (!status.connected) {
      forceNavigateToOffline()
    } else if (currentPath === '/error/no-connection') {
      window.location.replace('/')
    }
  }

  Network.addListener('networkStatusChange', async _status => {
    await checkNetworkAndNavigate()
  })

  App.addListener('resume', async () => {
    await checkNetworkAndNavigate()
  })

  await checkNetworkAndNavigate()
})
